import { Route, Routes } from "react-router-dom";
import { HomePage } from "./pages";

function App() {
    return (
        <div className="w-full md:w-4/5 lg:w-3/4 xl:w-2/3 2xl:w-2/4 h-full mx-auto antialiased">
            <div className="border-l border-r h-full border-stroke text-white flex flex-col items-center justify-between">
                <Routes>
                    <Route
                        path="/"
                        element={<HomePage />}
                    />
                </Routes>
            </div>
        </div>
    );
}

export default App;
